












import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import { Popover } from "ant-design-vue";

@Component({
  name: "CUser",
  components: {
    APopover: Popover
  }
})
export default class CUser extends Base {
  private created() {
    // undo
  }

  private logout() {
    this._confirm({
      content: "确定退出？",
      onOk: () => {
        this._logout();
      }
    });
  }
}
